import React from "react";
import { TableRow, TableCell, Box, Skeleton } from "@mui/material";

const cellStyle = {
  padding: '10px 16px',
};

const ManualSkeleton = ({ isMembersView = false, isInviteView = false }) => {
  return (
    <TableRow
      sx={{
        backgroundColor: '#fff',
        borderRadius: '10px',
      }}
    >
      <TableCell
        sx={{
          ...cellStyle,
          border: 'none',
          minWidth: '32px',
          maxWidth: '32px',
          borderRadius: '10px 0 0 10px',
        }}
      >
        <Skeleton variant="circular" width={20} height={20} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Skeleton width={20} />
      </TableCell>

      {/* Date Invite column (only for invites view) */}
      {!isMembersView && (
        <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
          <Skeleton width={80} />
        </TableCell>
      )}

      {/* Member Info */}
      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton width={100} height={20} />
            <Skeleton width={80} height={16} />
          </Box>
        </Box>
      </TableCell>

      {/* Status */}
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={60} height={24} />
      </TableCell>

      {/* Role */}
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={60} />
      </TableCell>

      {/* Projects */}
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={80} height={30} variant="rectangular" />
      </TableCell>

      {/* Payment */}
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={60} />
      </TableCell>

      {/* Limits */}
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={60} />
      </TableCell>

      {/* Time Tracking Status (not for invites view) */}
      {!isInviteView && (
        <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
          <Skeleton width={80} />
        </TableCell>
      )}

      {/* Date Added (not for invites view) */}
      {!isInviteView && (
        <TableCell
          sx={{
            ...cellStyle,
            border: 'none',
            textAlign: 'center',
            borderRadius: '0px 10px 10px 0px',
          }}
        >
          <Skeleton width={80} />
        </TableCell>
      )}

      {/* Action (only for invites view) */}
      {!isMembersView && (
        <TableCell
          sx={{
            ...cellStyle,
            border: 'none',
            textAlign: 'center',
            borderRadius: '0px 10px 10px 0px',
          }}
        >
          <Skeleton width={60} />
        </TableCell>
      )}
    </TableRow>
  );
};

export default ManualSkeleton;
